module.exports = __webpack_public_path__ + "img/QRPaymentEN.3ee7494d.png";